export default __webpack_public_path__ + "static/media/bimma-williams-320.9e1d6663.jpg";